module.exports = __webpack_public_path__ + "img/oufu_88x108x11b.prt.4e39b5d3.jpg";